'use client';

import { Wrench } from 'lucide-react';
import { StatsCard } from '@/core/presentation/components/StatsCard';
import { kpiData, servicesByCategory } from '@/features/admin/presentation/data/mockData';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const COLORS = ['#0D1B5E', '#1A2E7A', '#4AB8E0', '#7ECFEF', '#B8E8F7'];

export function DashboardServicos() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4">
        <StatsCard
          title="Total serviços"
          value={kpiData.totalServices.toLocaleString('pt-BR')}
          icon={<Wrench className="h-5 w-5 text-admin-cyan-dark" />}
          trend={5.1}
          gradient
        />
      </div>

      <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
        <h3 className="text-sm font-semibold text-admin-text mb-4">Serviços por categoria</h3>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={servicesByCategory}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={110}
              label={{ fontSize: 12, fill: '#2D3748' }}
            >
              {servicesByCategory.map((_, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

